import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  clientName?: string;
  brandName?: string;
  shopName?: string;
  workTitle?: string;
};

export const SelectedClientInfo: FC<Props> = ({ clientName, brandName, shopName, workTitle }) => {
  return (
    <div className={styles.wrapper}>
      <b className={styles.title}>投稿先が設定されました</b>
      <div className={styles.contents}>
        {clientName && <p>企業名：{clientName}</p>}
        {brandName && <p>ブランド名：{brandName}</p>}
        {shopName && <p>店舗名：{shopName}</p>}
        {workTitle && <p>{workTitle}</p>}
      </div>
    </div>
  );
};
